import { useSearchParams } from "next/navigation"


interface filters {
    title?: string
    filterDpendentFilters?: any
    filterIndDpendentFilters?: any
    location_ids?: number[]
    category_ids?: number[]
    city_ids?: number[]
    min_price?: number,
    max_price?: number,
    orderBy?: {
        price: string,
        discount: string
    },
    currentPage?: number,
    price?: {
        from: number,
        to: number,

    },
}

interface prop {
    filters: filters,
    detectChange: boolean,
    specs?: boolean
}

export const configureParams = ({ filters, detectChange, specs }: prop) => {
    const searchParams = useSearchParams();


    let paramss = new URLSearchParams();

    if (filters?.title) {
        paramss.append("search", filters?.title);
    }
    if (filters.filterDpendentFilters) {
        Object.keys(filters.filterDpendentFilters).map((val) => {

            if (val.includes("is_")) {
                paramss.append(
                    `${val}`,
                    `${filters.filterDpendentFilters[val].map((item: any) => {
                        return item.label;
                    })}`
                );
            }
            else if (val === 'model') {
                paramss.append(`models`, `[${filters.filterDpendentFilters[val].map((item: any) => `"${item.label}"`).join(",")}]`);
            }
            else {
                paramss.append(specs ? `${val}` : `${val}_ids`, `[${filters.filterDpendentFilters[val].map((item: any) => item.id).join(",")}]`);
            }
        });
    }

    if (filters.filterIndDpendentFilters) {
        Object.keys(filters.filterIndDpendentFilters).map((val) => {
            if (val === "category" || val === "city") {
                paramss.append(`${val}_id`, `${filters.filterIndDpendentFilters[val].map((item: any) => item.id).join(",")}`);
            } else {
                paramss.append(`${val}_ids`, `[${filters.filterIndDpendentFilters[val].map((item: any) => item.id).join(",")}]`);
            }
        });
    }
    if (filters?.orderBy?.price) {
        paramss.set("sort", `price:${filters?.orderBy?.price}`);
    }
    if (filters?.orderBy?.discount) {
        paramss.set("sort", `discount:${filters?.orderBy?.discount}`);
    }

    if (filters?.price && filters?.price?.from && filters?.price?.to) {
        paramss.append("priceFrom", `${filters?.price?.from}`);
        paramss.append("priceTo", `${filters?.price?.to}`);
    }
    if (filters?.currentPage) {
        paramss.append("page", `${filters?.currentPage}`);
    }
    let request = {
        params: paramss,
    };
    if (detectChange) {
        return request.params;
    } else {
        return new URLSearchParams(`${searchParams}`);
    }


}